<div class="gp-grid-table">
    <!-- Column headers -->
    <div class="gp-tile-col-headers">
        <button
            type="button"
            role="columnheader"
            class="gp-tile-col-hdr gp-tile-col--team"
            [attr.aria-sort]="
                _sortColumn === 'team'
                    ? _sortOrder === 'asc'
                        ? 'ascending'
                        : 'descending'
                    : 'none'
            "
            (click)="_onSortClick('team')"
        >
            {{ _i18n._11287_TEAM | translate }}
            <ng-container
                *ngTemplateOutlet="sortIcon; context: { column: 'team' }"
            ></ng-container>
        </button>
        <button
            type="button"
            role="columnheader"
            class="gp-tile-col-hdr gp-tile-col--persona"
            [attr.aria-sort]="
                _sortColumn === 'persona'
                    ? _sortOrder === 'asc'
                        ? 'ascending'
                        : 'descending'
                    : 'none'
            "
            (click)="_onSortClick('persona')"
        >
            <span class="gp-col-hdr-text">{{
                _i18n._11290_PERSONA | translate
            }}</span>
            <ng-container
                *ngTemplateOutlet="sortIcon; context: { column: 'persona' }"
            ></ng-container>
        </button>
        <button
            type="button"
            role="columnheader"
            class="gp-tile-col-hdr gp-tile-col--oa"
            [attr.aria-sort]="
                _sortColumn === 'oa'
                    ? _sortOrder === 'asc'
                        ? 'ascending'
                        : 'descending'
                    : 'none'
            "
            (click)="_onSortClick('oa')"
        >
            {{ _i18n._11288_OA | translate }}
            <ng-container
                *ngTemplateOutlet="sortIcon; context: { column: 'oa' }"
            ></ng-container>
        </button>
        <button
            type="button"
            role="columnheader"
            class="gp-tile-col-hdr gp-tile-col--wp"
            [attr.aria-sort]="
                _sortColumn === 'wp'
                    ? _sortOrder === 'asc'
                        ? 'ascending'
                        : 'descending'
                    : 'none'
            "
            (click)="_onSortClick('wp')"
        >
            {{ _i18n._11289_WIN_PCT | translate }}
            <ng-container
                *ngTemplateOutlet="sortIcon; context: { column: 'wp' }"
            ></ng-container>
        </button>
        <button
            type="button"
            role="columnheader"
            class="gp-tile-col-hdr gp-tile-col--nba"
            [attr.aria-sort]="
                _sortColumn === 'nba'
                    ? _sortOrder === 'asc'
                        ? 'ascending'
                        : 'descending'
                    : 'none'
            "
            (click)="_onSortClick('nba')"
        >
            {{ _i18n._11291_NEXT_BEST_ACTION | translate }}
            <ng-container
                *ngTemplateOutlet="sortIcon; context: { column: 'nba' }"
            ></ng-container>
        </button>
        <div class="gp-tile-col-hdr gp-tile-col--actions">
            {{ _i18n._11309_OTHER_ACTIONS | translate }}
        </div>
    </div>

    <!-- Empty state -->
    <div
        class="cmps-cdk-p-1dot5 cmps-cdk-text-center"
        *ngIf="!(rows?.length > 0)"
    >
        <div class="cmps-cdk-font-size-13p cmps-gp-color-ukn-105">
            {{ _i18n._11310_NO_PERFORMERS | translate }}
        </div>
    </div>

    <!-- Rows -->
    <div
        class="gp-tile-rows"
        *ngIf="rows?.length > 0"
    >
        <ng-container
            *ngFor="let r of _sortedRows; let rl = last; trackBy: _trackByRow"
        >
            <div
                class="gp-tile-row"
                [class.gp-tile-row--last]="rl"
            >
                <!-- Name / Avatar -->
                <div class="gp-tile-col--team">
                    <cmps-icon
                        class="cmps-cdk-w-28px cmps-cdk-h-28px cmps-cdk-nested:cmps-cdk-w-inherit cmps-cdk-nested:cmps-cdk-h-inherit {{
                            r.persona?.iconFill
                        }}"
                        svgIcon="account-circle"
                    ></cmps-icon>
                    <span
                        class="cmps-cdk-line-clamp-2 cmps-cdk-font-size-13p"
                        >{{ r.name }}</span
                    >
                </div>

                <!-- Persona pill -->
                <div class="gp-tile-col--persona">
                    <span
                        class="gp-persona-pill {{
                            r.persona?.rowClassList
                        }} gp-persona-pill--text"
                    >
                        {{ r.persona?.label | translate }}
                    </span>
                    <span
                        class="gp-persona-pill {{
                            r.persona?.rowClassList
                        }} gp-persona-pill--icon"
                        [cmpsTooltipTrigger]="r.persona?.label | translate"
                        [attr.aria-label]="r.persona?.label | translate"
                    >
                        <cmps-icon
                            class="cmps-cdk-w-24px cmps-cdk-h-24px cmps-cdk-nested:cmps-cdk-w-inherit cmps-cdk-nested:cmps-cdk-h-inherit"
                            [svgIcon]="r.persona?.icon"
                            aria-hidden="true"
                        ></cmps-icon>
                    </span>
                </div>

                <!-- OA -->
                <div
                    class="gp-tile-col--oa"
                    role="img"
                    [attr.aria-label]="r.oaLabel | translate"
                >
                    <cmps-icon
                        class="cmps-cdk-w-24px cmps-cdk-h-24px cmps-cdk-nested:cmps-cdk-w-inherit cmps-cdk-nested:cmps-cdk-h-inherit {{
                            r.oaColour
                        }}"
                        [svgIcon]="r.oaIcon"
                        aria-hidden="true"
                    ></cmps-icon>
                </div>

                <!-- WP -->
                <button
                    type="button"
                    class="gp-tile-col--wp focus:not:focus-visible:cmps-cdk-outline-0 cmps-cdk-border-width-0p cmps-cdk-p-0 cmps-cdk-bg-color-transparent"
                    [class.cmps-cdk-cursor-pointer]="r.wpCanClick"
                    [disabled]="!r.wpCanClick"
                    [attr.aria-label]="(r.wpLabel | translate) + ' — ' + r.name"
                    (click)="wpClick.emit(r)"
                >
                    <cmps-icon
                        class="cmps-cdk-w-24px cmps-cdk-h-24px cmps-cdk-nested:cmps-cdk-w-inherit cmps-cdk-nested:cmps-cdk-h-inherit {{
                            r.wpColour
                        }}"
                        [svgIcon]="r.wpIcon"
                    ></cmps-icon>
                </button>

                <!-- Next Best Action -->
                <div class="gp-tile-col--nba">
                    <ng-container *ngIf="r.groupedAction == null">
                        <cmps-gp-no-action></cmps-gp-no-action>
                    </ng-container>
                    <ng-container *ngIf="r.groupedAction != null">
                        <cmps-gp-action
                            [groupedAction]="r.groupedAction"
                            [isBest]="true"
                            [name]="r.name"
                        ></cmps-gp-action>
                    </ng-container>
                </div>

                <!-- Other Actions -->
                <div class="gp-tile-col--actions">
                    <ng-container *ngFor="let a of r.otherGroupedActions">
                        <cmps-gp-action
                            [groupedAction]="a"
                            [name]="r.name"
                        ></cmps-gp-action>
                    </ng-container>
                </div>
            </div>
        </ng-container>
    </div>
</div>

<ng-template
    #sortIcon
    let-column="column"
>
    <cmps-icon
        svgIcon="unfold-more-horizontal"
        *ngIf="_sortColumn !== column"
        class="gp-tile-sort-icon"
    ></cmps-icon>
    <cmps-icon
        svgIcon="chevron-up"
        *ngIf="_sortColumn === column && _sortOrder === 'asc'"
        class="gp-tile-sort-icon"
    ></cmps-icon>
    <cmps-icon
        svgIcon="chevron-down"
        *ngIf="_sortColumn === column && _sortOrder === 'desc'"
        class="gp-tile-sort-icon"
    ></cmps-icon>
</ng-template>
